export default {"src":"/_next/static/media/bg-hero.319d0298.svg","height":692,"width":1280,"blurWidth":0,"blurHeight":0};